import script from "./SeleryRecord.vue?vue&type=script&setup=true&lang=js"
export * from "./SeleryRecord.vue?vue&type=script&setup=true&lang=js"

import "./SeleryRecord.vue?vue&type=style&index=0&id=01d5c5b5&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01d5c5b5"]])

export default __exports__